import { validateUrl } from '../validators/websiteValidator';

/**
 * Normalizes a URL by ensuring it has a proper protocol.
 * If the URL is missing a protocol, it defaults to HTTPS.
 *
 * @param url - The URL string to normalize (can be null/undefined)
 * @returns The normalized URL string with protocol, or empty string if invalid input
 */
const normalizeUrl = (url?: string | null): string => {
  if (!url || typeof url !== 'string') {
    return '';
  }
  const isValidUrl = validateUrl(url);

  // If the URL is invalid regardless of protocol, return an empty string
  if (!isValidUrl) {
    return '';
  }

  try {
    new URL(url);
    return url;
  } catch {
    return `https://${url}`;
  }
};

export { normalizeUrl };
